import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";

// Rutas principales (carga inmediata — son el core del sitio)
import Index from "./screens/Index/Index";
import Productos from "./screens/Productos/Productos";
import Clientes from "./screens/Clientes/Clientes";
import Contacto from "./screens/Contacto/Contacto";
import ProductoDetalle from "./screens/ProductoDetalle/ProductoDetalle";
import ErrorPage from "./screens/Error/Error";
import Blog from "./screens/Blog/Blog";

// Lazy — rutas menos visitadas
const SinglePostPage  = lazy(() => import("./screens/Blog/SinglePostPage"));
const LandingEstaciones = lazy(() => import("./screens/LandingPage/Estaciones-de-servicio/Estaciones-de-servicio"));
const AdminLogin      = lazy(() => import("./screens/Autogestion/AdminLogin"));
const PanelAdmin      = lazy(() => import("./screens/Autogestion/PanelAdmin"));

const Loader = () => (
  <div style={{ display: 'flex', justifyContent: 'center', padding: '4rem', color: '#cb3234' }}>
    Cargando...
  </div>
);

const PublicLayout = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
  </>
);

const App = () => (
  <Router>
    <Suspense fallback={<Loader />}>
      <Routes>
        {/* Principales */}
        <Route path="/" element={<PublicLayout><Index /></PublicLayout>} />
        <Route path="/clientes" element={<PublicLayout><Clientes /></PublicLayout>} />
        <Route path="/productos" element={<PublicLayout><Productos /></PublicLayout>} />
        <Route path="/contacto" element={<PublicLayout><Contacto /></PublicLayout>} />
        <Route path="/productos/:categoria" element={<PublicLayout><ProductoDetalle /></PublicLayout>} />

        {/* Blog */}
        <Route path="/blog" element={<PublicLayout><Blog /></PublicLayout>} />
        <Route path="/blog/:slug" element={<PublicLayout><SinglePostPage /></PublicLayout>} />

        {/* Landing */}
        <Route path="/LandingPage/:categoria" element={<PublicLayout><LandingEstaciones /></PublicLayout>} />

        {/* Admin — sin Header ni Footer */}
        <Route path="/admin" element={<Navigate to="/admin/productos" replace />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/productos" element={
          <PrivateRoute><PanelAdmin /></PrivateRoute>
        } />

        {/* 404 */}
        <Route path="*" element={<PublicLayout><ErrorPage /></PublicLayout>} />
      </Routes>
    </Suspense>
  </Router>
);

export default App;
